export default __webpack_public_path__ + "media/images/icons/arrow-prev-2-7d6cd6b50386f131e55c573d71126f73.svg";